import { getEnvironmentAppUrls } from '@dvag/dfs-constant-config';
import type { FC } from 'react';
import { createElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { getDevEnv } from 'service/envConfig';

export const elementName = 'dvag-wuensche-und-ziele';

const webComponentPath = '/wuensche-und-ziele.webcomponent.js';
const styleSheetPath = '/wuensche-und-ziele.webcomponent.css';

export const getWebComponentUrls = () => {
  const baseUrl = getEnvironmentAppUrls(getDevEnv()).wuenscheUndZiele;

  return {
    script: `${baseUrl}${webComponentPath}`,
    styleSheet: `${baseUrl}${styleSheetPath}`,
  };
};

const appendOnce = (selector: string, create: () => HTMLElement) => {
  if (!document.head.querySelector(selector)) {
    document.head.appendChild(create());
  }
};

export const loadWebComponent = () => {
  const { script, styleSheet } = getWebComponentUrls();

  appendOnce(`link[href="${styleSheet}"]`, () => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = styleSheet;
    return link;
  });

  appendOnce(`script[src="${script}"]`, () => {
    const element = document.createElement('script');
    element.src = script;
    return element;
  });
};

interface WuenscheUndZieleWebComponentProps {
  hideFinancialGrade?: boolean;
  isSalesforce?: boolean;
}

export const WuenscheUndZieleWebComponent: FC<WuenscheUndZieleWebComponentProps> = ({
  hideFinancialGrade = false,
  isSalesforce = false,
}) => {
  const { householdId, personId } = useParams<{ householdId: string; personId: string }>();

  useEffect(() => {
    loadWebComponent();
  }, []);

  return createElement(elementName, {
    'household-id': householdId,
    ...(personId ? { kundennummer: personId } : {}),
    ...(hideFinancialGrade ? { 'hide-financial-grade': '' } : {}),
    ...(isSalesforce ? { salesforce: '' } : {}),
  });
};
